/**
 * abilityVfxSkirmisherMeshes — Shape dispatch for SPY-812 skirmisher wave (OCP).
 */
import {
  buildSteelTempest,
  buildWindWall,
  buildSweepingBlade,
  buildLastBreath,
  buildBrokenWings,
  buildKiBurst,
  buildValor,
  buildBladeOfTheExile,
  buildBladesurge,
  buildDefiantDance,
  buildFlawlessDuet,
  buildVividBlade
} from './abilityVfxSkirmisher.js';

const SKIRMISHER_SHAPE_BUILDERS = {
  steel_tempest: buildSteelTempest,
  wind_wall: buildWindWall,
  sweeping_blade: buildSweepingBlade,
  last_breath: buildLastBreath,
  broken_wings: buildBrokenWings,
  ki_burst: buildKiBurst,
  valor: buildValor,
  blade_of_the_exile: buildBladeOfTheExile,
  bladesurge: buildBladesurge,
  defiant_dance: buildDefiantDance,
  flawless_duet: buildFlawlessDuet,
  vivid_blade: buildVividBlade
};

/** @returns {object|null} */
export function buildSkirmisherAbilityMesh(THREE, spec) {
  const build = SKIRMISHER_SHAPE_BUILDERS[spec?.shape];
  return build ? build(THREE, spec) : null;
}
